export const KEYS = {
    FILTER: 'filter'
};

export const ROLES = {
    SUPER_ADMINISTRATOR: "Super Administrator",
    ADMINISTRATOR: 'Administrator',
    OPERATIONS: 'Operations',
    DRIVER: 'Driver'
};
